// extracted by mini-css-extract-plugin
export default {"container":"Contact_container__cTq3S","box":"Contact_box__s80Ky","info":"Contact_info__Z9-un"};